import type { CheckboxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

//
import {
  CheckboxCheckedIcon,
  CheckboxIcon,
  CheckboxIndeterminateIcon,
} from './CustomIcons';

const Checkbox = (theme: Theme) => {
  return {
    MuiCheckbox: {
      defaultProps: {
        checkedIcon: <CheckboxCheckedIcon />,
        icon: <CheckboxIcon />,
        indeterminateIcon: <CheckboxIndeterminateIcon />,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: CheckboxProps }) => ({
          padding: theme.spacing(1),
          ...(ownerState.size === 'small' && {
            '& svg': { height: 20, width: 20 },
          }),
          ...(ownerState.size === 'medium' && {
            '& svg': { height: 24, width: 24 },
          }),
        }),
      },
    },
  };
};

export default Checkbox;
